import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import * as d3 from 'd3';
import { iWeek } from '../chart.interfaces';


function getStartWeekDate(d = null){
  const now = new Date(d) || new Date();
  now.setHours(0, 0, 0, 0);
  const sunday = new Date(now);
  sunday.setDate(sunday.getDate() - sunday.getDay()+1 );
  sunday.setHours(0,0,0,0);
  return sunday;
}
function getEndWeekDate(d = null){
  let start = getStartWeekDate(d);
  start.setDate(start.getDate() +5);
  start.setHours(11,59,59,0);
  return start;
}

function getWeekNumber(date) {
  date = new Date(date);
  const sunday = getStartWeekDate(date);
  return sunday.toISOString().replace(/T.+/,'');
}
function groupByWeek( objects:any[], dateProp: string ){
  return objects.reduce( ( grouped:any,o:any)=>{
    if(!o[dateProp]){
      return grouped;
    }
    const value = o[dateProp];
    const week = getWeekNumber(value);
    if(!grouped[week]){
      grouped[week]=[];
    }
    grouped[week].push(o);
    return grouped;
  },{})
}

function getPileTimeline(piles:any[],id:string){
  if(!getPileTimeline.__ref){
    getPileTimeline.__ref = {};
    return getPileTimeline(piles,id);
  }
  const stored = getPileTimeline.__ref[id];
  if(stored){
    return stored;
  }
  const foundIndex = piles.findIndex( (p:any)=>{
    return p.id == id;
  });
  if(~foundIndex){
    getPileTimeline.__ref[id]=piles[foundIndex].timeline;
    return getPileTimeline.__ref[id];
  }
  return [];
}
getPileTimeline.__ref= {};



@Component({
  selector: 'app-sector-timeline',
  templateUrl: './sector-timeline.component.html',
  styleUrls: ['./sector-timeline.component.scss'],
})
export class SectorTimelineComponent implements AfterViewInit {
  @Input() set data(piles:any[]){
    this._piles = piles;
    this.prepareData();

  }
  private width:number=1000;
  private height:number=40;
  private margin:any = {
    top:0,
    left:0,
    bottom:0,
    right:0
  }
  private _piles:any[] = [];
  private timelines:any[] = [];
  private svg:any;
  private weeks:iWeek[] = [];
  constructor() { }
  ngAfterViewInit(): void {

    this.createSvg();
    this.drawChart('created','limegreen');
    this.drawChart('modified', 'orange');
    this.drawChart('transported','red');
  }



  createSvg(){
    const {width,height,margin}=this;
    this.svg = d3.select("#timeline").append("svg")
    .attr("width", '100%')
    .attr("height", '100%')
    .attr("viewBox", `0 0 ${width} ${height}`)
    // .attr("height", height + margin.top + margin.bottom)
    .append("g")

    .attr("transform",
          `translate(0,0)`);
  }
  drawChart(dateProp:string,color:string){
    const {width,height,margin}=this;
    const x = d3.scaleTime().range([0,width]);
    const y = d3.scaleLinear().range([height-20,0]);
    const data:iWeek[] = [...this.weeks].sort( (a:any,b:any)=>{
      a = new Date(a.start).getTime();
      b = new Date(b.start).getTime();
      return a - b;
    });
    const area = d3.area()
      .x( (d:any)=>{ return x(d.start) })
      .y0(height-20)
      .y1((d:any)=>{ return y(Math.abs(d[`${dateProp}Volume`]))})
      .curve(d3.curveMonotoneX);
    const valueLine = d3.line()
      .x( (d:any)=>{ return x(d.start) })
      .y((d:any)=>{ return y(Math.abs(d[`${dateProp}Volume`]))})
       .curve(d3.curveMonotoneX);
      x.domain(d3.extent( data, (d:any)=>{ return d.start }));
      y.domain([0, d3.max( data, (d:any)=>{ return Math.abs(d[`${dateProp}Volume`]) })]);
    this.svg.append('path')
    .data([data])
    .attr('class','area area-created')
    .attr('d', area )
    .attr('fill', color)
    .attr('fill-opacity',0.3)
    this.svg.append('path')
    .data([data])
    .attr('class','line line-created')
    .attr('d', valueLine )
    .attr('fill', 'none')
    .attr('stroke',color).style('stroke-width','3px');
    this.svg.append('g')
      .attr('transform', `translate(0,${height-20})`)
      .call(d3.axisBottom(x).tickFormat(d3.timeFormat("%Y-%m-%d")))
      // .call(xTics)
      .style('stroke','none')
      .style('color','transparent')
      this.svg.selectAll("text").style("fill", "#999").style('stroke','none');


    // this.svg.append('g')
    //   .call(d3.axisLeft(y));
  }

  prepareData(){
    let init:any[]=[];
    const weeks:any[]=Array.from(new Set( this._piles.reduce( (all:any[],p:any)=>{
      if(p.created){
        let value =  getWeekNumber(p.created.getTime());
        if(value){
            all.push(value);
        }
      }
      if(p.modified){
        let value =  getWeekNumber(p.modified.getTime());
        if(value){
            all.push(value);
        }
      }
      if(p.transported){
        let value =  getWeekNumber(p.transported.getTime());
        if(value){
            all.push(value);
        }
      }

      return all;
    },init))).filter( (v:string)=>{ return !/NaN/.test(v) });
    const hour = 3600000;
    const byWeekCreated = groupByWeek(this._piles,'created');
    const byWeekModified = groupByWeek(this._piles,'modified');
    const byWeekTransported = groupByWeek(this._piles,'transported');
    this.weeks = weeks.map( ( w:string)=>{
      return {
        token: w,
        start: new Date(w),
        end:getEndWeekDate(w)
      }
    }).map( (week:any)=>{
      const {start,end,token} = week;
      const created = byWeekCreated[token]||[];
      const modified = byWeekModified[token]||[];
      const transported = byWeekTransported[token]||[];

      const transportedVolume = transported.reduce( (t:number,p:any)=>{
        return t + p.volume;
      },0);
      const createdVolume = created.reduce(  (t:number,p:any)=>{
        return t + p.volume;
      },0);
      let modifiedVolume = modified.reduce(  (t:number,p:any)=>{
        return t + p.volume;
      },0);

      if(createdVolume && modifiedVolume){

        modifiedVolume-=createdVolume
      }

      return {
        start,end,token,createdPiles:created.length,modifiedPiles:modified.length,transportedPiles:transported.length,
        transportedVolume,
        createdVolume,
        modifiedVolume

      }
    }).sort( (a,b)=>{
      return a.start - b.start;
    })
    const peakCreated = this.weeks.reduce( (p:number,w:any)=>{
      return Math.max(p,w.createdVolume);
    },0);
    const peakModified = this.weeks.reduce( (p:number,w:any)=>{
      return Math.max(p,w.modifiedVolume);
    },0);
    const peakTransported = this.weeks.reduce( (p:number,w:any)=>{
      return Math.max(p,w.transportedVolume);
    },0);

    // console.log(this.weeks, {peakCreated,peakModified,peakTransported})
  }
}
